import { AuthLinkButton, AuthLinks } from '../../authModal.styles';

const AuthFormStepLinks = ({ isLogin, onForgotPassword, translations }) => {
	if (!isLogin) {
		return null;
	}

	return (
		<AuthLinks>
			<AuthLinkButton onClick={onForgotPassword} type="button">
				{translations.forgotPasswordLink || 'Forgot password?'}
			</AuthLinkButton>
		</AuthLinks>
	);
};

export default AuthFormStepLinks;
